// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__2vr_l","list":"index_list__sLoWF","vs":"index_vs__j56ZA"};